import styled from 'styled-components'

export const IFrameContainer = styled.div`
  height: calc(100vh - 82px); // 82px is the header height
  width: 300px;
  margin: 0 auto;
`

export const IFrameHeader = styled.p`
  font-size: 20px;
  text-align: center;
  margin: 20px 0;
  line-height: 25px;
`

export const IFrameBody = styled.div`
  height: calc(100vh - 82px - 25px - 40px - 15px - 20px);
  width: 300px;
  border-radius: 20px;
  iframe {
    transform: scale(0.75) translate(-15.5%, -16.5%);
    /* @media (min-width: 1360px) {
    } */
  }
`

export const IFrameFooter = styled.p`
  font-size: 14px;
  color: #b0b0b0;
  text-align: center;
  margin: 10px 0;
  line-height: 15px;
`
